import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormField, Input, Select } from "ui";

import { MoreLessOptions } from "../NotificationForm.constants";
import { NotificationFormValues } from "../NotificationForm.types";

import styles from "../NotificationForm.module.scss";

export const SharesFields = () => {
  const { t } = useTranslation();
  const { control, register, watch } = useFormContext<NotificationFormValues>();

  const notRelevantSharesWatch = watch("notRelevantShares");

  return (
    <div className={styles.form_separatedBlock}>
      <FormField
        label={t("Number of Shares")}
        labelClassName={styles.form_fieldLabel}
      >
        <div className={styles.form_twoColumnsBlock}>
          <Controller
            control={control}
            name={"sharesType"}
            render={({ field: { value, onChange } }) => (
              <Select
                value={value}
                options={MoreLessOptions}
                onChange={onChange}
                disabled={notRelevantSharesWatch}
              />
            )}
          />

          <Input
            type="number"
            {...register("sharesValue")}
            disabled={notRelevantSharesWatch}
          />
        </div>

        <Controller
          control={control}
          name="notRelevantShares"
          render={({ field: { value, onChange } }) => (
            <Checkbox
              checked={value}
              label={t("Not Relevant")}
              onChange={onChange}
              className={styles.form_checkbox}
            />
          )}
        />
      </FormField>
    </div>
  );
};
